export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image1-ac4d7b6783522b72e91cbe78e4f9c9f8.png";